import { createVNode as a, mergeProps as l } from "vue";
import m from "./ADialog.js";
import { extend as p } from "../composables/use-expose.js";
import { mountComponent as s, usePopupState as c } from "../utils/mount-component.js";
let e;
function f() {
  ({
    instance: e
  } = s({
    setup() {
      const {
        state: r,
        toggle: n
      } = c();
      return () => a(m, l(r, {
        "onUpdate:visible": n
      }), null);
    }
  }));
}
function o(t) {
  return new Promise((r, n) => {
    e || f(), e.open(p({}, t, {
      callback: (i) => {
        (i === "confirm" ? r : n)(i);
      }
    }));
  });
}
o.alert = o;
o.confirm = (t) => o(p({
  showCancelButton: !0
}, t));
o.close = () => {
  e && e.toggle(!1);
};
export {
  o as Dialog
};
